import { render } from "./VerticalDragArrows.vue?vue&type=template&id=39f790e8&scoped=true"
import script from "./VerticalDragArrows.vue?vue&type=script&lang=js"
export * from "./VerticalDragArrows.vue?vue&type=script&lang=js"

import "./VerticalDragArrows.vue?vue&type=style&index=0&id=39f790e8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Taitaen Swegon Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f790e8"]])

export default __exports__